import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreTo, moreLabel = "查看更多" }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-start gap-3">
        {icon && (
          <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center mt-0.5 shrink-0">
            <i className={`${icon} text-lg`}></i>
          </span>
        )}
        <div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}